
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSleetShowersDayColour as ObiLightningSleetShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-sleet-showers-day-colour.js';
 
 
 

 
 export const ObiLightningSleetShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-lightning-sleet-showers-day-colour',
   elementClass: ObiLightningSleetShowersDayColourElement,
   events: {
     
   }
  });
 
 